import filter from 'lodash/filter'
import map from 'lodash/map'
import { GET_RADAR_SETS_SUCCESS } from './actionTypes'

const initialState = []

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case GET_RADAR_SETS_SUCCESS:
            return filter(
                map(payload, set => ({
                    value: set.id,
                    ...set
                })),
                set => set.id
            )
        default:
            return state
    }
}
